import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingConfigurationPackagingActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Packaging/PackagingBrowser")
	}

	render() {
		return (
			<Activity 
				name="Packaging"
				RenderedComponent={this.RenderedComponent}
				context="Packaging"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingConfigurationPackagingActivity)
